import { asset } from 'Services/BaseHelpers';

const VerisureIcon = ({ icon, active, onClick, title }) => {
    return (
        <div>
            <div className={`${active ? '' : 'border-opacity-0'} border-app-yellow p-1 lg:p-2 border border-dashed rounded-full`}>
                <div
                    className={`w-12 h-12 lg:w-28 lg:h-28 border-2 border-app-black bg-app-turquoise bg-opacity-10 rounded-full flex items-center justify-center ${onClick && 'cursor-pointer'}`}
                    onClick={onClick}
                >
                    <img
                        src={asset(`/images/hazard/${icon}`)}
                        className="h-5 lg:h-12"
                    />
                </div>
            </div>

            <p className="text-xs lg:text-lg text-white rubrik-regular text-center mt-2">{title}</p>
        </div>
    );
};

export default VerisureIcon;
